import { useTranslation } from 'react-i18next';

export default function FinalCtaSection() {
  const { t } = useTranslation();

  return (
    <section id="cta" className="w-full relative overflow-hidden py-20 md:py-28">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Row%20of%20luxury%20designer%20handbags%20and%20accessories%20on%20marble%20surface%20with%20soft%20studio%20lighting%20cream%20and%20beige%20tones%20premium%20retail%20display&width=1600&height=700&seq=cta-bg-02&orientation=landscape"
          alt="Fashion products"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50" />
      </div>

      <div className="relative z-10 section-container">
        <div className="section-inner text-center max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-5 font-heading">
            {t('final_cta_title')}
          </h2>
          <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8">
            {t('final_cta_desc')}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('final_cta_primary')}
              <i className="ri-arrow-right-line" />
            </a>
            <button
              onClick={() => {
                const el = document.getElementById('categories');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md border-2 border-white/60 text-white font-semibold text-base hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('final_cta_secondary')}
            </button>
          </div>

          {/* External CTA buttons row */}
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-white/10 backdrop-blur-sm text-white font-semibold text-sm hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer border border-white/20"
            >
              <i className="ri-external-link-line" />
              {t('ext_btn_main')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-white font-semibold text-sm hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-bag-line" />
              {t('ext_btn_buy')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}